
import React from 'react';
import ReferralCodeDisplay from '@/components/ReferralCodeDisplay';
import ReferralQRCode from '@/components/ReferralQRCode';
import PrintableReferralCard from '@/components/PrintableReferralCard';
import ReferralForm from '@/components/ReferralForm';

interface DashboardSidebarComponentProps {
  points: number;
  lastMonthEarnings: number;
  lifetimeEarnings: number;
  signupDate: string;
  referralCode?: string;
  referralLink?: string;
  referrerName?: string;
  onSendReferral?: (data: any, method: string) => Promise<void>;
}

const DashboardSidebarComponent: React.FC<DashboardSidebarComponentProps> = ({
  points,
  lastMonthEarnings,
  lifetimeEarnings,
  signupDate,
  referralCode = '',
  referralLink = '',
  referrerName = '',
  onSendReferral
}) => {
  const handleSendReferral = async (data: any, method: string) => {
    if (onSendReferral) {
      await onSendReferral(data, method);
    }
  };

  return (
    <div className="space-y-6 bg-gray-50 p-4 rounded-lg">
      {/* Stats section */}
      <div className="p-4 bg-white rounded-lg border shadow-sm">
        <h3 className="font-medium text-lg mb-2">Your Referral Stats</h3>
        <div className="grid grid-cols-2 gap-3 mb-3">
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-sm text-gray-500">Points Earned</p>
            <p className="text-xl font-bold text-blue-700">{points}</p>
          </div>
          <div className="bg-green-50 p-3 rounded-lg">
            <p className="text-sm text-gray-500">Last Month</p>
            <p className="text-xl font-bold text-green-700">${lastMonthEarnings.toFixed(2)}</p>
          </div>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Lifetime Earnings:</span>
            <span className="font-medium">${lifetimeEarnings.toFixed(2)}</span>
          </div>
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-500">Member Since:</span>
            <span className="font-medium">{signupDate}</span>
          </div>
        </div>
      </div>

      {referralCode && (
        <>
          <ReferralCodeDisplay referralCode={referralCode} />
          
          {referralLink && (
            <div className="p-4 bg-white rounded-lg border shadow-sm">
              <h3 className="font-medium text-lg mb-3">Your Referral QR Code</h3>
              <ReferralQRCode referralLink={referralLink} />
            </div>
          )}
          
          {referralLink && referrerName && (
            <div className="p-4 bg-white rounded-lg border shadow-sm">
              <h3 className="font-medium text-lg mb-3">Business Card</h3>
              <PrintableReferralCard 
                referralLink={referralLink}
                referralCode={referralCode}
                referrerName={referrerName}
              />
            </div>
          )}
          
          {referralLink && onSendReferral && (
            <ReferralForm 
              referralLink={referralLink}
              referralTemplate={`Hey! I thought you might like this awesome product. Use my referral link to sign up and we both get rewards! ${referralLink}`}
              onSendReferral={handleSendReferral}
            />
          )}
        </>
      )}
    </div>
  );
};

export default DashboardSidebarComponent;
